import {TeamMemberCard} from './TeamMemberCard';
import type {TeamMember} from '@/types/api';

interface TeamMemberTableProps {
    members: TeamMember[];
}

export function TeamMemberTable({members}: TeamMemberTableProps) {
    return (
        <div className="studio-team-grid">
            {members.map(member => <TeamMemberCard key={member.id} member={member} />)}
        </div>
    );
}
